export default __webpack_public_path__ + "static/media/screen9.9458958e.png";